// Рекурсивно удаляет ключи со значением undefined из объектов. Массивы и
// примитивы (включая null) возвращает как есть, сохраняя длину/значение.
//
// Зачем нужно: react-hook-form Controller'ы регистрируют поля в форме ещё до
// взаимодействия пользователя, и watch() начинает возвращать эти ключи со
// значением undefined. Persisted-снапшот из бэка таких ключей не содержит —
// deepEqual видит разную длину Object.keys и любая isDirty-проверка по watch()
// залипает в true сразу после маунта. Утилита нормализует оба снапшота перед
// сравнением.
//
// Ограничения: работает только на plain JSON-ish структурах. Date/Map/Set/
// RegExp/File попадут в ветку typeof === "object" и схлопнутся в {}. Цикличные
// ссылки уйдут в бесконечную рекурсию.

// out создаётся через Object.create(null), чтобы исключить активацию сеттера
// Object.prototype.__proto__ при присваивании ключа "__proto__" из недоверенного
// JSON (defense-in-depth). См. OWASP Prototype Pollution Prevention.

export function omitUndefinedDeep<T>(value: T[]): T[];
export function omitUndefinedDeep<T extends object>(value: T): Partial<T>;
export function omitUndefinedDeep<T>(value: T): T;
export function omitUndefinedDeep(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((v) => omitUndefinedDeep(v));
  }
  if (value !== null && typeof value === "object") {
    const out: Record<string, unknown> = Object.create(null);
    for (const [k, v] of Object.entries(value)) {
      if (v === undefined) continue;
      out[k] = omitUndefinedDeep(v);
    }
    return out;
  }
  return value;
}
